import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../models";
import { getCustomerExistingAccounts } from "../../../state/selectors/customerSelectors";
import AccountSelector from "../AccountSelector";
import { CustomerSection } from "../CustomerSection";
import "./ExistingSubscriptions.less";

const ExistingSubscriptions = () => {
    const existingAccounts = useSelector((state: RootState) => getCustomerExistingAccounts(state));
    const numberOfAccounts = existingAccounts.length;

    const heading = numberOfAccounts > 0 ? "Eksisterende abonnementer" : "Ingen eksisterende abonnement";

    if (numberOfAccounts > 0) {
        return (
            <CustomerSection className="existing-subscriptions" heading={heading}>
                <AccountSelector />
            </CustomerSection>
        );
    }
    return null;
};

export default ExistingSubscriptions;
